import Styles from './Button.module.scss'

export default function Button({ children, ...props }) {
    return (
        <>
            <button {...props} className={Styles.button}>{children}</button>
        </>
    )
}